import React from 'react'
import PredictionTimeline from '../PredictionTimeline'
import PredictionView from './PredictionView'
import { PadithiEnum } from '../../../utils/enums'

const Predictions = ({ filter, user, predictionData }) => {
	return (
		<>
			{PadithiEnum.LAL_KITAB === filter.conditionType &&
				<PredictionTimeline
					filter={filter}
					user={user}
				/>
			}
			<PredictionView
				predictionData={predictionData}
				user={user}
				filter={filter}
			/>
		</>
	)
}

export default Predictions